/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_LogoutInputs */

const en_us2_search_field_logout = /** @type {(inputs: Search_Field_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out`)
};

const pt_br2_search_field_logout = /** @type {(inputs: Search_Field_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair`)
};

const es_419_search_field_logout = /** @type {(inputs: Search_Field_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión`)
};

const pt_pt2_search_field_logout = /** @type {(inputs: Search_Field_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar sessão`)
};

const fr_fr2_search_field_logout = /** @type {(inputs: Search_Field_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se déconnecter`)
};

const de_de2_search_field_logout = /** @type {(inputs: Search_Field_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

const it_it2_search_field_logout = /** @type {(inputs: Search_Field_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esci`)
};

/**
* | output |
* | --- |
* | "Sign out" |
*
* @param {Search_Field_LogoutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_logout = /** @type {((inputs?: Search_Field_LogoutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_LogoutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_logout(inputs)
	if (locale === "es-419") return es_419_search_field_logout(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_logout(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_logout(inputs)
	if (locale === "de-DE") return de_de2_search_field_logout(inputs)
	if (locale === "it-IT") return it_it2_search_field_logout(inputs)
	return en_us2_search_field_logout(inputs)
});
export { search_field_logout as "search.field_logout" }